'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _Branding2.default();

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.USER_PROFILE_FETCH_SUCCEEDED, function (state, action) {
  var _action$payload$brand = action.payload.branding,
      primaryColor = _action$payload$brand.primaryColor,
      logoUrl = _action$payload$brand.logoUrl;


  return state.set('primaryColor', primaryColor).set('logoUrl', logoUrl);
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_GLOBAL_BRANDING_FETCH_SUCCEEDED, function (state, action) {
  if (action.payload && action.payload.primaryColor !== null) {
    var _action$payload = action.payload,
        primaryColor = _action$payload.primaryColor,
        logoUrl = _action$payload.logoUrl;

    return state.set('primaryColor', primaryColor).set('logoUrl', logoUrl);
  }
  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/branding.js
// module id = 520
// module chunks = 0